import PropTypes from 'prop-types';
import React from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "../../assets/images/zithasLogo.png";
import { withTranslation } from 'react-i18next';
import ConfigUrl from "../../config"


const Header = props => {

  function tToggle() {
    var body = document.body;
    if (window.screen.width <= 998) {
      body.classList.toggle("sidebar-enable");
    } else {
      body.classList.toggle("vertical-collpsed");
      body.classList.toggle("sidebar-enable");
    }

  }
  const path = useLocation();

  return (
    <React.Fragment>
      <header id="page-topbar" className='d-block d-xl-none'>
        <div className="navbar-header">
          <div className="d-flex justify-content-between w-100">
            <Link to={`${ConfigUrl.appurl}welcome${path?.search}`} className="logo logo-dark ms-3">
              <span className="logo-sm">
                <img src={logo} alt="" height="42" />
              </span>
            </Link>
            <button
              type="button"
              onClick={() => {
                tToggle();
              }}
              className="btn btn-sm px-3 font-size-16 header-item d-block d-xl-none"
              id="vertical-menu-btn"
            >
              <i className="fa fa-fw fa-bars" />

            </button>
          </div>
        </div>
      </header>
    </React.Fragment>
  );
};

Header.propTypes = {
  changeSidebarType: PropTypes.func,
  leftMenu: PropTypes.any,
  leftSideBarType: PropTypes.any,
  showRightSidebar: PropTypes.any,
  showRightSidebarAction: PropTypes.func,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func
};

export default withTranslation()(Header);
